var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v(" "+_vm._s(_vm.$t('back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }